<template>
    <div>
        <a-breadcrumb class="breadcrumb">
            <a-breadcrumb-item>首页</a-breadcrumb-item>
            <a-breadcrumb-item>教务数据分析</a-breadcrumb-item>
            <a-breadcrumb-item>试听统计</a-breadcrumb-item>
        </a-breadcrumb>
        <div class="main-box">
            <div class="clearfix table-tools">
                <div class="buttons">
                </div>
                <div class="search">
                    <a-form layout='inline'>
                    <a-form-item>
                      <a-radio-group :value="paramsData.filter_type" @change="handleButChange">
                        <a-radio-button value="day">
                            日
                        </a-radio-button>
                        <a-radio-button value="week">
                            周
                        </a-radio-button>
                        <a-radio-button value="month">
                            月
                        </a-radio-button>
                        <a-radio-button value="year">
                            年
                        </a-radio-button>
                        </a-radio-group>
                    </a-form-item>
                    <a-form-item>
                        <a-tooltip placement="topLeft" >
                        <template slot="title">
                            <span>时间筛选</span>
                        </template>
                        <a-range-picker
                            :ranges="rangesData"
                            :value='rangesValue'
                            :allowClear="false"
                            :default-value="[moment(paramsData.start_date,'YYYY-MM-DD'),moment(paramsData.end_date,'YYYY-MM-DD')]"  style="width: 240px"
                            @change="(date, dateString)=>onChange(date, dateString,1)" />
                        </a-tooltip>
                    </a-form-item>

                    <a-form-item>
                      <a-tooltip placement="topLeft" >
                      <template slot="title">
                          <span>上课校区</span>
                      </template>
                      <a-select allowClear showSearch placeholder="请选择校区" mode="multiple" :maxTagCount="1" :maxTagTextLength='5' :filterOption="filterOption" @change="handleChange" style="width: 220px;">
                          <a-select-option v-for="(d, index) of studios" :key="index" :value="d['studio_id']">{{ d['filter_name'] }}</a-select-option>
                      </a-select>
                      </a-tooltip>
                    </a-form-item>


                    <a-form-item>
                        <a-button @click="toScreen" :loading="loading" type="primary">筛选</a-button>
                    </a-form-item>

                    <a-form-item>
                          <a-popover placement="bottom" trigger="click" v-model="visible">
                          <template slot="content">
                              <div class="more-search">
                              <a-form layout='inline'>
                                  <a-form-item class="block-line" label="员工名称">
                                      <a-select mode="multiple" :maxTagCount="1" :maxTagTextLength='5' v-model='paramsData.employee_id' allowClear showSearch @search="handleSearch" placeholder="请选择员工账户" :filterOption="filterOption">
                                      <a-select-option v-for="(d, index) of staffList" :key="index" :value="d['employee_id']">{{ d['filter_name'] }}</a-select-option>
                                      </a-select>
                                  </a-form-item>
                              </a-form>
                              <div class="more-search__buttons">
                                  <a-button type="dashed" @click="visible=false">取消</a-button>
                                  <a-button @click="reset">重置</a-button>
                                  <a-button type="primary" @click="toScreen">搜索</a-button>
                              </div>
                              </div>
                          </template>
                          <a-button>更多<a-icon type="down" /></a-button>
                          </a-popover>
                      </a-form-item>


                    </a-form>
                </div>
            </div>
            <div class="dashboard bk-group">
                <statistics :count='counts' :col="3"/>
                <a-row class="mb16" :gutter="16">
                    <a-col :lg="24" :xl="24">
                        <auditionChart :loading='loadingCH'  :leads_data ='auditionData' :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col>

                    <a-col :lg="24" :xl="24">
                        <sankey :loading ='loadingS' :link='link' :maxLength='maxLength' :sankey_title="sankey_title"  :sankey_data ='sankey_data' :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col>


                    <a-col :lg="24" :xl="24">
                      <a-card size="small" title="员工试听排课产出统计">
                        <a-button slot="extra" @click="toExport" size="small" icon="export" :loading="exportLoading">导出</a-button>
                        <vue-element-loading :active="loading" color="#00cca2" spinner="spinner"/>
                        <a-table size="small" :pagination="false" :bordered='false' rowKey="employee_id"
                        :columns="col_teacher_book_columns" :dataSource="col_teacher_book" :scroll="{ x: RelativeWidth, y:500}">
                        </a-table>
                      </a-card>
                    </a-col>

                    <a-col :lg="24" :xl="12">
                      <LRanking title="员工试听排课学员统计" :rank_data="arrange_teacher_audition" :loading="loading" :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col>

                    <a-col :lg="24" :xl="12">
                      <LRanking title="校区试听排课学员统计" :rank_data="arrange_studio_audition" :loading="loading" :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col>

                    <a-col :lg="24" :xl="12">
                      <LRanking title="员工试听上课学员统计" :rank_data="teacher_audition" :loading="loading" :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col>

                    <a-col :lg="24" :xl="12">
                      <LRanking title="校区试听上课学员统计" :rank_data="studio_audition" :loading="loading" :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col>

                    <a-col :lg="24" :xl="12"  v-if="auditionChannelData.invited_channel">
                      <LRanking title="渠道试听学员统计" :rank_data="auditionChannelData.invited_channel" :loading="loading" :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col>

                    <a-col :lg="24" :xl="12" v-if="auditionChannelData.invited_channel_cate">
                      <LRanking title="渠道大类试听学员统计" :rank_data="auditionChannelData.invited_channel_cate" :loading="loading" :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col>

                    <!-- <a-col :lg="24" :xl="24">
                      <heatmap :loading="loadingHT" :item="heatmapData" title="学员上课热点图" :start_date='paramsData.start_date' :end_date='paramsData.end_date'  />
                    </a-col>
                    <a-col :lg="24" :xl="12">
                        <teacher :loading='loading' :item ='teacherData' :start_date='paramsData.start_date' :end_date='paramsData.end_date'/>
                    </a-col>
                    <a-col :lg="24" :xl="12">
                        <teacherCourse :loading='loadingC' :item ='teacherCData' :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col> -->
                    <!-- <a-col :lg="24" :xl="12">
                        
                    </a-col>
                    <a-col :lg="24" :xl="12">
                        <LRanking title="校区上课学员统计" :rank_data="studioStudents" :loading="loadingTS" :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col>
                    <a-col :lg="24" :xl="12">
                        <LRanking title="老师排课数据统计" :rank_data="teacherSData" :loading="loadingS" :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col>
                    <a-col :lg="24" :xl="12">
                        <LRanking title="老师授课学员统计" :rank_data="teacherBData" :loading="loadingB" :start_date='paramsData.start_date' :end_date='paramsData.end_date' />
                    </a-col> -->
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import ranges from "@/common/mixins/ranges"
import moment from 'moment'
import sankey from './sankey'
// import teacher from './teacher'
// import teacherCourse from './teacherCourse'
import heatmap from './heatmap'
import auditionChart from './auditionChart'
import statistics from '@/views/bi/ranking/money/statistics'
export default {
  name: 'audition',
  components:{
    heatmap,
    sankey,
    auditionChart,
    // teacher,
    // teacherCourse,
    statistics
  },
  data() {
    return {
      visible:false,
      loading:false,
      loadingB:false,
      loadingC:false,
      loadingS:false,
      loadingCH:false,
      loadingHT:false,
      loadingTS:false,
      loadingCHL:false,
      exportLoading:false,
      maxLength:'',
      sankey_data:{},
      sankey_title:'',
      link:{},
      staffList:[],
      col_teacher_book:[],
      col_teacher_book_columns:[],
      auditionData:{},
      teacherData:{},
      heatmapData:{},
      teacherCHData:{},
      teacherBData:{},
      teacherCData:{},
      teacherSData:{},
      studioCourses:{},
      studioStudents:{},
      teacher_audition:{},
      studio_audition:{},
      arrange_teacher_audition:{},
      arrange_studio_audition:{},
      studios:[],
      counts:[],
      auditionChannelData:{},
      paramsData:{
        start_date:moment().startOf('month').format('YYYY-MM-DD'),
        end_date:moment().format('YYYY-MM-DD'),
        studio_id:'',
        filter_type:'day',
      },
    }
  },
  mixins: [ranges],
  created() {
    this.rangesValue = [moment(this.paramsData.start_date,'YYYY-MM-DD'),moment(this.paramsData.end_date,'YYYY-MM-DD')]
    this.toScreen()
    this.getStudio()
    this.getStaff()
  },
  computed: {
      RelativeWidth() {
          let width = 850
          if(this.filedLength >10){
          width = 900 + ( this.filedLength - 10 ) * 130
          }
          return width
      }
  },

  methods: {
    moment,
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getList(obj){
      this.getCount(obj)
      this.getAudition(obj)
      this.getSankey(obj)
      this.getRank(obj)
      this.getAuditionChannel(obj)
      // this.getTeacherChart(obj)
      // this.getTeacher(obj)
      // this.getHeatmap(obj)
      // this.getTeacherSummate(obj)
      // this.getTeacherCourse(obj)
      // this.getTeacherBook(obj)
      // this.getTeacherStudio(obj)
    },
    async getAudition(obj){
      this.loadingCH = true
      let res = await this.$store.dispatch('analysisAuditionAction', obj)
      this.auditionData = res.data
      this.loadingCH = false  
    },
    async getAuditionChannel(obj){
      this.loadingCHL = true
      let res = await this.$store.dispatch('analysisAuditionChannelAction', obj)
      this.auditionChannelData = res.data
      this.loadingCHL = false  
    },
    async getSankey(obj){
      this.loadingS = true
      let res = await this.$store.dispatch('analysisAuditionSankeyAction', obj)
      this.sankey_data = res.data.rows
      this.sankey_title = res.data.title
      this.link = res.data.link
      let lengthObj = res.data.length
      let arr = []
      for(var i in res.data.length){
          arr.push(lengthObj[i])
      }
      this.maxLength = Math.max(...arr)
      this.loadingS = false
    },
    async getRank(obj){
        this.loading = true
        let res = await this.$store.dispatch('analysisAuditionRankAction', obj)
        this.teacher_audition=res.data.teacher_audition;
        this.studio_audition=res.data.studio_audition;
        this.arrange_teacher_audition=res.data.arrange_teacher_audition;
        this.arrange_studio_audition=res.data.arrange_studio_audition;


      let single_col_date = 
       [
          { title: '#', width:'55px', customRender:(text,record,index)=>`${index+1}`, key: 'index', fixed: 'left'},
          { title: '员工名称', width:'160px', dataIndex: 'employee_name',  key: 'employee_name', fixed: 'left',ellipsis:true},
          { title: '合计', width:'120px', dataIndex: 'employee_book_total', key: 'employee_book_total',fixed: 'left',align:'right'},
      ]
      if(res.data.teacher_date_audition){
          res.data.teacher_date_audition.col_date.map(item=>{
              let obj = { title: item, dataIndex: item, key: item,align:'right',width:'90px'}
              single_col_date.push(obj)
          })
      }

      this.col_teacher_book_columns=single_col_date;
      this.col_teacher_book = res.data.teacher_date_audition.rows;

      this.loading = false
    },
    async getTeacher(obj){
      this.loading = true
      let res = await this.$store.dispatch('analysisTeacherAction', obj)
      this.teacherData = res.data
      this.loading = false
    },
    async getTeacherSummate(obj){
      this.loadingS = true
      let res = await this.$store.dispatch('analysisTeacherSummateAction', obj)
      this.teacherSData = res.data
      this.loadingS = false
    },
    async getTeacherCourse(obj){
      this.loadingC = true
      let res = await this.$store.dispatch('analysisTeacherCourseAction', obj)
      this.teacherCData = res.data
      this.loadingC = false
    },
    async getTeacherBook(obj){
      this.loadingB = true
      let res = await this.$store.dispatch('analysisTeacherBookAction', obj)
      this.teacherBData = res.data
      this.loadingB = false
    },
    async getTeacherChart(obj){
      this.loadingCH = true
      let res = await this.$store.dispatch('analysisTeacherChartAction', obj)
      this.teacherCHData = res.data
      this.loadingCH = false
    },
    async getTeacherStudio(obj){
      this.loadingTS = true
      let res = await this.$store.dispatch('analysisTeacherStudioAction', obj)
      this.studioCourses = res.data.courses
      this.studioStudents = res.data.students
      this.loadingTS = false
    },
    async getHeatmap(obj){
      this.loadingHT = true
      let res = await this.$store.dispatch('analysisTeacherHeatmapAction', obj)
      this.heatmapData = res.data
      this.loadingHT = false
    },
    async getStaff(val){
        let obj = {q:val}
        let res = await this.$store.dispatch('searchAccountEmployeeAction', {params:obj})
        this.staffList = res.data
    },
    async getStudio() {
      let res = await this.$store.dispatch('searchBelongStudioAction', {})
      this.studios = res.data
    },
    async getCount(obj){
      let res = await this.$store.dispatch('analysisTeacherCountAction', obj)
      this.counts = res.data
    },
    handleSearch(val){
        this.getStaff(val)
    },
    handleButChange(e){
      this.paramsData.filter_type = e.target.value
      this.toScreen()
    },
    handleChange(value){
      this.paramsData.studio_id = value;
    },
    reset(){
      this.paramsData.studio_id = undefined
      this.paramsData.employee_id = undefined
    },
    async toExport(){
        this.exportLoading = true
        let exportData = {
            search:this.paramsData
        }
        let res = await this.$store.dispatch('analysisAuditionExportAction', exportData)
        const blob = new Blob([res], {type: 'application/vnd.ms-excel'})
        if ('download' in document.createElement('a')) { 
            const link = document.createElement('a')
            link.download = `员工试听排课产出统计.${moment().format('YYYY.MM.DD')}.xlsx`
            link.style.display = 'none'
            link.href = URL.createObjectURL(blob)
            document.body.appendChild(link)
            link.click()
            URL.revokeObjectURL(link.href) 
            document.body.removeChild(link)
        } else { //其他浏览器
            navigator.msSaveBlob(blob, fileName)
        }

        this.exportLoading = false
    },
    toScreen(){
      let obj = {
        search:this.paramsData
      }
      this.getList(obj);
    }
  }
}
</script>